import { useEffect } from "react";

const SSO_BASE_URL = import.meta.env.VITE_SSO_BASE_URL;
const SSOLoginPage = () => {
  useEffect(() => {
    if (SSO_BASE_URL) {
      window.location.href = decodeURIComponent(SSO_BASE_URL);
    }
  }, [])

  return null;
}

export default SSOLoginPage;